import PropTypes from 'prop-types';
import {cloneElement} from 'react';
import {connect} from 'react-redux';
import SkeletonSection from '../../pages/SkeletonPage/SkeletonSection';
import GenericFallbackSuspense from '../../v2/components/ui/GenericFallback/GenericFallbackSuspense';
import {isMobile} from '../../v2/selectors/DeviceSelectors';
import {isCollapsibleExperiment} from '../../v2/selectors/ExperimentSelectors';

export function ProgressStep(props) {
  if (props.hidden) return null;
  return (
    <GenericFallbackSuspense fallback={<SkeletonSection step={props.step} />}>
      {cloneElement(props.children, {
        isStepActive: props.isStepActive,
        isStepCollapsed: props.isStepCollapsed,
        isStepPending: props.isStepPending,
      })}
    </GenericFallbackSuspense>
  );
}

ProgressStep.propTypes = {
  // Own props
  step: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  
  // Mapped props
  hidden: PropTypes.bool.isRequired,
  isStepActive: PropTypes.bool.isRequired,
  isStepCollapsed: PropTypes.bool.isRequired,
  isStepPending: PropTypes.bool.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const activeStep = state.ui.checkoutProgressStep;
  const isStepActive = activeStep === ownProps.step;
  const isInCollapsibleExperiment = isCollapsibleExperiment(state);
  return ({
    isStepActive,
    isStepCollapsed: ownProps.step < activeStep && isInCollapsibleExperiment,
    isStepPending: ownProps.step > activeStep && isInCollapsibleExperiment,
    hidden: isMobile(state) && !isStepActive && !isInCollapsibleExperiment,
  });
};

export default connect(mapStateToProps)(ProgressStep);
